export const fieldTranslations = {
  // General information
  name: "Nom",
  currency: "Devise",
  isin: "ISIN",
  code: "Code",
  company_name: "Société de gestion",
  asset_class_1: "Classe d'actif principale",
  asset_class_2: "Classe d'actifs",

  a9_issuer_name: "Emetteur",

  // Technical information
  strategy_id: "ID de la stratégie",

  // Other loan fields
  loan_rate: "Taux du prêt",
  loan_amount_granted: "Montant du prêt accordé",
  loan_with_collateral: "Prêt consenti avec nantissement",
  concentrated_asset: "Actif concentré du client",

  maturity_date: "Date de maturité",
  coupon_rate: "Taux du coupon",
  commitment: "Engagement Initial",
  capital_callable: "Capital Exigible",
  owner: "Propriétaire",
  property_id: "ID de la propriété",
  property_type: "Type de bien",
  property_size: "Taille du bien",
  financing_own_funds: "Financement fonds propres",
  financing_mortage: "Financement hypothécaire",
  stock_option_strike: "Prix d'exercice",

  // Technical fields
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
